'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsVisiblyOffline = exports.getChannelsWithNetworkIssues = exports.getStatusByChannel = exports.getIsResubscribing = exports.getPubNubStatus = undefined;

var _reselect = require('reselect');

var _PubNubStatusCategories = require('conversations-core/constants/PubNubStatusCategories');

var PubNubStatusCategories = _interopRequireWildcard(_PubNubStatusCategories);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getPubNubStatus = exports.getPubNubStatus = function getPubNubStatus(state) {
  return state.pubNubStatus;
};

var getIsResubscribing = exports.getIsResubscribing = (0, _reselect.createSelector)([getPubNubStatus], function (pubNubStatus) {
  return pubNubStatus.get('isResubscribing');
});

var getStatusByChannel = exports.getStatusByChannel = (0, _reselect.createSelector)([getPubNubStatus], function (pubNubStatus) {
  return pubNubStatus.get('statusByChannel');
});

var getChannelsWithNetworkIssues = exports.getChannelsWithNetworkIssues = (0, _reselect.createSelector)([getStatusByChannel], function (statusByChannel) {
  return statusByChannel.filter(function (status) {
    return status.category === PubNubStatusCategories.NETWORK_ISSUES;
  }).keySeq();
});

var getIsVisiblyOffline = exports.getIsVisiblyOffline = (0, _reselect.createSelector)([getPubNubStatus], function (pubNubStatus) {
  return pubNubStatus.get('visiblyOffline');
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/selectors/pubNubStatusSelectors.js
// module id = 119
// module chunks = 0 1